
import {
    defineComponent,
    ref,
    inject,
    onMounted,
    reactive
} from 'vue'
import Swal from "sweetalert2/dist/sweetalert2.min.js";

//components
import AddEdit from "./AddEdit.vue"

//services
import {
    errManager,
    showMessage
} from "@/core/config/Tools";
import personService from '@/core/services/PersonService';
import sanService from '@/core/services/SanctionService'

export default defineComponent({
    props: {
        idperson: {
            type: String,
            required: true,
            default: ""
        }
    },
    components: {
        AddEdit
    },

    setup(props) {
        const gblDialog = inject < any > ('gblDialog')
        const gblAction = inject < any > ('gblAction')

        const listSantions = ref([])
        const loader = ref(false)
        const rowItem = ref({})

        const onRegister = () => {
            gblAction.value = 'new';
            gblDialog.value = true
        }

        const onEdit = (row) => {
            rowItem.value = row
            gblAction.value = 'edit';
            gblDialog.value = true
        }

        const response = (data) => {
            gblDialog.value = false
            showMessage(data)
            if (data.status == 'success')
                getSanctions()
        }

        const getSanctions = async () => {
            loader.value = true
            listSantions.value.length = 0
            personService.getSanctions(props.idperson)
                .then((res) => {
                    loader.value = false
                    listSantions.value = res.data
                }).catch(({
                    response
                }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onDelete = (row) => {
            Swal.fire({
                title: 'Eliminar sanción',
                text: `¿Desea eliminar la sanción ${row.num_resolution} de forma permanente?`,
                icon: 'warning',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Mantener',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return sanService.delete(row.idsanction)
                    .then( (res) => {
                        return res.data
                    }).catch(({response}) => {
                        Swal.showValidationMessage(
                        `Request failed: ${response}`
                        )
                    })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    result.value.status === 'success' && getSanctions();
                }   
            })
        }

        onMounted(() => {
            getSanctions()
        })

        return {
            loader,
            listSantions,
            onRegister,
            onEdit,
            onDelete,
            response,
            getSanctions,
            rowItem
        }

    },
})
